module.exports = "img/photo15.cf6c60.jpeg";